module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg4.04f2b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg4.jpg
// module id = +h4X
// module chunks = 7